/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import PropTypes from 'prop-types';

const propTypes = {
  testID: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  data: PropTypes.array,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  orientation: PropTypes.string,
  containerStyle: PropTypes.object,
  isWrap: PropTypes.bool,
  maxWidth: PropTypes.number,
  hasError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const defaultProps = {
  testID: 'radio-button',
  value: '',
  data: [],
  disabled: false,
  label: '',
  orientation: 'horizontal',
  containerStyle: {},
  isWrap: false,
  maxWidth: 0,
  hasError: false,
};

const RadioButton = (props) => {
  const {
    testID = 'radio-button',
    value = '',
    data = [],
    disabled = false,
    label = '',
    orientation = 'horizontal',
    containerStyle = {},
    isWrap = false,
    maxWidth = 0,
    onChange = () => {},
    hasError = false,
  } = props;

  const [checked, setChecked] = useState(value || '');
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onSelected = (val) => {
    try {
      if (!disabled) {
        setChecked(val);
        onChange(val);
      }
    } catch (error) {}
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setChecked(value?.value ? value.value : value);
      if (hasError) {
        setIsError(true);
        setErrorMessage(hasError);
      } else {
        setIsError(false);
        setErrorMessage('');
      }
    }
    return () => {
      mounted = false;
    };
  }, [value, hasError]);

  return (
    <View testID={testID} style={containerStyle}>
      {label ? (
        <SociollaText style={styles.label}>{label}</SociollaText>
      ) : (
        false
      )}
      <View
        style={{
          flexDirection: orientation === 'horizontal' ? 'row' : 'column',
          ...(isWrap && orientation === 'horizontal'
            ? { flexWrap: 'wrap' }
            : {}),
          ...(maxWidth ? { maxWidth: maxWidth } : {}),
        }}>
        {data.map((res, idx) => {
          const isItemDisabled = disabled || res.disabled;
          return (
            <TouchableOpacity
              testID={
                checked === res.value
                  ? `${testID}-option-${idx}-selected`
                  : `${testID}-option-${idx}`
              }
              key={'radio-' + res.value + idx}
              style={[styles.container, isItemDisabled && { opacity: 0.4 }]}
              onPress={() => !isItemDisabled && onSelected(res.value)}
              activeOpacity={isItemDisabled ? 1 : 0.2}>
              <View
                style={[
                  styles.radioCircle,
                  { borderColor: isError ? Colors.red0 : Colors.grey10 },
                ]}>
                {checked === res.value ? (
                  <View style={styles.selectedRb} />
                ) : (
                  false
                )}
              </View>
              <SociollaText style={styles.radioText}>{res.label}</SociollaText>
            </TouchableOpacity>
          );
        })}
      </View>
      {isError && (
        <SociollaText style={styles.errorMessage}>{errorMessage}</SociollaText>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginVertical: 8,
    paddingLeft: 8,
  },
  label: {
    fontSize: 12,
    color: Colors.black3,
    marginBottom: 10,
  },
  radioText: {
    fontSize: 12,
  },
  radioCircle: {
    height: 16,
    width: 16,
    borderRadius: 100,
    borderWidth: 2,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12,
  },
  selectedRb: {
    width: 10,
    height: 10,
    borderRadius: 50,
    backgroundColor: '#0028e4',
  },
  errorMessage: {
    fontFamily: 'figtree-regular',
    fontSize: 12,
    lineHeight: 16,
    color: Colors.red1,
    margin: 0,
    transition: 'all 0.3s ease',
  },
});

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export default React.memo(RadioButton, (prev, next) => prev == next);
